/**
 * Auto-scrolling Google reviews marquee.
 * Reviews are sourced from `src/data/reviews.ts` (single source of truth
 * for both homepage and Testimonials page).
 */
import { reviews } from "@/data/reviews";

export function ReviewsMarquee() {
  const featuredReviews = reviews.slice(0, 6);
  const loop = [...featuredReviews, ...featuredReviews];

  return (
    <section className="bg-ink text-bone py-24 md:py-32 overflow-hidden">
      <div className="container-prose text-center">
        <p className="eyebrow text-ember">
          <span className="rule" />Google Reviews
        </p>
        <h2 className="mt-4 font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight">
          REAL PARENTS. <span className="italic text-ember animate-underline">REAL DIFFERENCE.</span>
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-lg text-bone/75 leading-relaxed">
          Don't just take our word for it—see how families are experiencing the Side Kicks
          difference and watching their children build confidence, develop life skills, and
          grow into their best selves.
        </p>
        <div className="mt-6 flex items-center justify-center gap-2 text-ember text-lg">
          ★★★★★ <span className="text-bone/70 text-sm tracking-wider uppercase ml-2">{reviews.length}+ Five-Star Reviews</span>
        </div>
      </div>

      <div
        className="reviews-marquee mt-14"
         style={{ ["--marquee-duration" as string]: "48s" }}
      >
        <div className="reviews-marquee-track">
          {loop.map((r, i) => (
            <article key={i} className="review-card">
              <div className="text-ember text-lg">★★★★★</div>
              <p className="mt-3 font-serif italic text-bone/95 leading-relaxed">
                "{r.quote}"
              </p>
              <div className="mt-5 flex items-center gap-3">
                <div className="h-9 w-9 rounded-full bg-ember/20 text-ember flex items-center justify-center font-semibold">
                  {r.name.charAt(0)}
                </div>
                <div className="text-left">
                  <p className="text-sm font-semibold text-bone">{r.name}</p>
                  <p className="text-xs text-bone/80">Google Review</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
